// extracted by css-extract-rspack-plugin
export default {"cls1":"Comments-cls1_XXL","cls2":"Comments-cls2_D7w Comments-cls1_XXL"};